// extracted by mini-css-extract-plugin
export default {"enlargeable":"ImageWithPopup_enlargeable__YkH9W"};